import Superadmin from "@src/views/superadmin";

// ─── TEMPORARY ────────────────────────────────────────────────────────────────
// Internal onboarding console, kept deliberately self-contained. To remove it:
//   1. delete this file and src/views/superadmin/
//   2. drop the SuperadminRoutes import and spread in ./index.jsx
// Nothing else references it — no nav entry, no CASL subject, no shared imports.
//
// Public + blank layout on purpose: the console's first job is creating the very
// first ops account, which by definition happens with no session in hand.
const SuperadminRoutes = [
    {
        path   : "/superadmin",
        element: <Superadmin />,
        meta   : {
            layout     : "blank",
            title      : "Superadmin",
            publicRoute: true
        }
    }
];

export default SuperadminRoutes;
